export const NAME_IS_REQUIRED = 'Name field is required';
export const MIN_CHAR_NAME_VALIDATION = 'Must be at least 2 characters';
export const MAX_CHAR_NAME_VALIDATION = 'Must be no more than 50 characters';

export const TEMPLATE_SELECTION_IS_REQUIRED = 'You must select a Template to overwrite.';
